import { Container, Sprite, TextStyle, Text } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { BuildingUpgradeItemResourcePackage } from "../resources/BuildingUpgradeItemResourcePackage";
import { HBox } from "../../../common/components/ui/HBox";
import { FixResult } from "../../../common/models/Building/upgrade/FixResult";
import { UpgradeResult } from "../../../common/models/Building/upgrade/UpgradeResult";

export class OwnerPiggyClubContainer extends Container {

    public constructor(upgradeItemResources: BuildingUpgradeItemResourcePackage, upgradeOrFixResult: FixResult | UpgradeResult) {
        super();
        const rewardBox = new HBox(2);
        const buildingPercentText = new Text(`[${Math.round(upgradeOrFixResult.piggyMultiplier * 100 - 100)}%`, new CountTextStyle());
        rewardBox.addChild(buildingPercentText);

        const buildingIcon = new Sprite(upgradeItemResources.assets_views_building_upgrade_item_building_icon_png);
        buildingIcon.position.y = -16.5;
        rewardBox.addChild(buildingIcon);

        const piggyClubMiltiplier = new Text(`+ ${Math.round(upgradeOrFixResult.piggyClubMultiplier * 100)}%`, new CountTextStyle());
        rewardBox.addChild(piggyClubMiltiplier);

        const piggyClubMiltiplierIcon = new Sprite(upgradeItemResources.assets_views_building_upgrade_item_piggy_club_icon_png);
        piggyClubMiltiplierIcon.width = 50;
        piggyClubMiltiplierIcon.height = 50;
        piggyClubMiltiplierIcon.position.y = -15;
        rewardBox.addChild(piggyClubMiltiplierIcon);
        this.addChild(rewardBox);

        const additionalText = new Text(`]`, new CountTextStyle());
        additionalText.position.set(rewardBox.x + rewardBox.width - 6, rewardBox.y);
        this.addChild(additionalText);
    }
}

class CountTextStyle extends TextStyle {
    public constructor() {
        super({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 32
        });
    }
}
